import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { EndpointBase } from './endpoint-base.service';

@Injectable()
export class AuthHeadersInterceptorService extends EndpointBase implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        const urlKeywords = ['token', 'openid-configuration'];
        if (!urlKeywords.some((substring) => request.url.includes(substring))) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + this.authService.accessToken,
                },
            });
        }
        return next.handle(request);
    }
}
